<script setup>
import { computed } from 'vue'
import { useMeta } from '@/stores/meta.js'

/**
 * A tag as it is shown everywhere: its category named in the category's colour, then the tag
 * — "Produkt | FenoOne" — so which category a tag belongs to is never a guess from a colour.
 */
const props = defineProps({
  name: { type: String, required: true },
  category: { type: Object, default: null }, // { name, color } (a list row, the tags API)
  categoryUuid: { type: String, default: null }, // or looked up in meta
  pending: Boolean,
  removable: Boolean,
  size: { type: String, default: 'sm' }, // xs (lists) | sm
})
const emit = defineEmits(['remove'])
const meta = useMeta()
const cat = computed(() => props.category || meta.tagCategory(props.categoryUuid) || null)
const color = computed(() => cat.value?.color || '#64748b')
const catName = computed(() => (cat.value ? meta.localized(cat.value.name) : ''))
</script>

<template>
  <span
    :class="['inline-flex max-w-full items-stretch overflow-hidden rounded-full border font-medium', size === 'xs' ? 'text-2xs' : 'text-xs', pending ? 'border-dashed' : '']"
    :style="{ borderColor: color }"
    :title="catName ? `${catName}: ${name}` : name"
  >
    <span v-if="catName" class="flex items-center px-1.5 text-white" :style="{ background: color }">{{ catName }}</span>
    <span class="flex min-w-0 items-center gap-1 px-1.5 py-0.5" :style="{ background: color + '14' }">
      <i v-if="pending" class="fa-solid fa-hourglass-half text-[9px] text-faint" :title="$t('record.tagPending')" aria-hidden="true"></i>
      <span class="truncate">{{ name }}</span>
      <button v-if="removable" type="button" class="opacity-60 hover:opacity-100" :aria-label="$t('common.remove')" @click="emit('remove')"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
    </span>
  </span>
</template>
